// src/components/EditorLayout.js
import React from "react";
import App from "../App";

/*
  EditorLayout:
  - Wraps the Zclipr editor inside a simple responsive layout.
  - Ready for Firebase Hosting or any React build setup.
*/

export default function EditorLayout() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#0a0a0a",
        color: "#fff",
        fontFamily: "Inter, system-ui, sans-serif",
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#111",
          padding: "12px 20px",
          borderBottom: "1px solid rgba(255,255,255,0.05)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1 style={{ fontSize: 20, fontWeight: "bold", color: "#00ff88" }}>
          🎬 Zclipr Editor
        </h1>
        <a
          href="https://studio.firebase.google.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#999", textDecoration: "none", fontSize: 14 }}
        >
          Firebase Studio ↗
        </a>
      </header>

      {/* Main content */}
      <main style={{ flex: 1, overflowY: "auto", padding: 16 }}>
        <App />
      </main>

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          padding: "8px 0",
          fontSize: 13,
          color: "#666",
          borderTop: "1px solid rgba(255,255,255,0.05)",
        }}
      >
        © {new Date().getFullYear()} Zclipr · Powered by Firebase
      </footer>
    </div>
  );
}
